export default __webpack_public_path__ + "static/media/img-guide-gt-popup-3-de_de.4ad60dc6.png";